import { createRouter, createWebHistory } from 'vue-router'
import VueRouteMiddleware from 'vue-route-middleware'
import auth from '@/middleware/auth'
import authAdmin from '@/middleware/authAdmin'
import authTrainingAdmin from '@/middleware/authTrainingAdmin'
import authPhishingAdmin from '@/middleware/authPhishingAdmin'
import superadmin_auth from '@/middleware/authSuperAdmin'

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import('../views/Main.vue'),
    redirect: 'dashboard',
    meta: {
      middleware: [auth],
      title: 'Core',
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Pages/Dashboard.vue'),
        meta: {
          title: 'Core',
        middleware: [authAdmin],
        },
      },
      {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: () => import('../views/Pages/NotFound'),
        meta: {
          title: 'Core',
        },
      },
    ],
  },
  // training routes
  {
    path: '/training',
    name: 'Training',
    redirect: '/training/assigned-training',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [auth],
      title: 'Core',
    },
    children: [
      {
        path: 'assigned-training',
        name: 'AssignedTraining',
        component: () => import('../views/Pages/user/training/AssignedTraining.vue'),
      },
      {
        path: '/assigned-training/:id/quiz',
        name: 'QuizTraining',
        component: () => import('../views/Pages/user/training/Quiz.vue'),
      },
      {
        path: 'completed-training',
        name: 'CompletedTraining',
        component: () => import('../views/Pages/user/training/CompletedTraining.vue'),
      },
      {
        path: 'settings',
        name: 'UserLibrarySettings',
        meta: {
          title: 'Core',
          middleware: [authTrainingAdmin],
        },
        component: () => import('../views/Pages/user/training/Settings.vue'),
      },
      {
        path: 'settings/library/module/:id/quiz',
        name: 'OrgModuleQuiz',
        meta: {
          title: 'Core',
          middleware: [authTrainingAdmin],
        },
        component: () => import('../views/Pages/admin/settings/library/Quiz.vue'),
      },
    ],
  },
   // phishing routes
   {
    path: '/phishing',
    name: 'Phishing',
    redirect: '/phishing/campaign-settings',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [auth],
      title: 'Core',
    },
    children: [
      {
        path: 'campaign-settings',
        name: 'PhishingCampaignSettings',
        meta: {
          title: 'Core',
          middleware: [authPhishingAdmin],
        },
        component: () => import('../views/Pages/user/phishing/Settings.vue'),
      },
    ],
  },
   // policy routes
   {
    path: '/policy',
    name: 'Policy',
    redirect: '/phishing/campaign-settings',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [auth],
      title: 'Core',
    },
    children: [
      {
        path: 'library',
        name: 'PolicyLibrary',
        component: () => import('../views/Pages/user/training/PolicyLibrary.vue'),
      },
      {
        path: 'compliance',
        name: 'PolicyCompliance',
        component: () => import('../views/Pages/user/training/PolicyCompliance.vue'),
      },
      {
        path: '/policy/view/:id',
        name: 'PolicyPreview',
        component: () => import('../components/policies/PolicyPreviewPage.vue'),
      },
    ],
  },
  // superadmin
  {
    path: '/admin/settings',
    name: 'Settings',
    redirect: '/admin/settings/scheduled-jobs',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [superadmin_auth],
      title: 'Core',
    },
    children: [
      {
        path: 'scheduled-jobs',
        name: 'ScheduledJobs',
        component: () => import('../views/Pages/admin/settings/job/Index.vue'),
      },
      {
        path: 'training-library',
        name: 'TrainingLibrary',
        component: () => import('../views/Pages/admin/settings/library/Index.vue'),

      },
      {
        path: 'training-library/:id/quiz',
        name: 'SettingsQuiz',
        component: () => import('../views/Pages/admin/settings/library/Quiz.vue'),
      },
      {
        path: 'training-library/:id/video',
        name: 'TrainingLibraryEdit',
        component: () => import('../views/Pages/admin/settings/library/Video.vue'),

      },
      {
        path: 'phishing-configuration',
        name: 'Phishing Configuration',
        component: () => import('../views/Pages/admin/settings/phishing/Index.vue'),

      },
    ],
  },
  {
    path: '/validation',
    name: 'Validation',
    component: () => import('../views/Validation'),
    meta: {
      title: 'Core',
    },
  },
]

if(typeof process.env.VUE_APP_DEPLOYMENT_ENV !== 'undefined' && (process.env.VUE_APP_DEPLOYMENT_ENV === 'local' || process.env.VUE_APP_DEPLOYMENT_ENV === 'development')) {

  // routes.push(
  //   {
  //     path: '/test',
  //     name: 'Test',
  //     component: () => import('../views/Test/Test.vue'),
  //     meta: {
  //       middleware: [authMiddleware],
  //       title: 'Vertex SOC',
  //     },
  //   },
  //   {
  //     path: '/test/mongodb',
  //     name: 'TestMongodb',
  //     component: () => import('../views/Test/Mongodb.vue'),
  //     meta: {
  //       middleware: [authMiddleware],
  //       title: 'Vertex SOC',
  //     },
  //   }
  // )
}


const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  try {
    await new Promise((resolve) => {
      VueRouteMiddleware({ auth })(to, from, resolve);
    });

    if (to.path !== '/validation/') {
      if (to.matched.length === 2 && to.matched[1].path.includes(':catchAll(.*)')) {
        localStorage.setItem('currentUrl', null);
      } else {
        localStorage.setItem('currentUrl', to.path);
      }
    }

    document.title = to.meta.title;
    next();
  } catch (error) {
    console.error('Navigation Error:', error);
  }
});

export default router;